import { render, staticRenderFns } from "./MessageAdmin.vue?vue&type=template&id=7df8e82f"
import script from "./MessageAdmin.vue?vue&type=script&lang=js"
export * from "./MessageAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports